import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-transfers',
  styleUrls: ['./recap-transfers.component.scss'],
  templateUrl: './recap-transfers.component.html'
})
export class RecapTransfersComponent {
  @Input() public day: any;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }
}
